import { RouteType } from "types/RouteType";
import InstanceDriftStore from "./InstanceDriftStore";

const deploymentStatusRoute: RouteType[] = [
  {
    name: "DeploymentStatus",
    path: "/infrastructure/deployment-status",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Deployment Status",
        enableRefreshButton: true,
        component: () => import("./DeploymentStatus.Header"),
      },
      body: {
        component: () => import("./DeploymentStatus"),
        grayBackground: true,
      },
    },
    group: "Infrastructure",
    searchAliases: ["deploys", "versions", "what is deployed"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.instanceDriftViewStore as InstanceDriftStore;
      store?.load();
      // Seed the global client list so the Client column can render names (and
      // link to Client 360) instead of raw ids — same seeding the DevOps
      // Connections route does for its client picker.
      const clientStore = (rootStore as Record<string, unknown>).clientStore as
        | { fetchClients?: () => Promise<void>; clients?: unknown[] }
        | undefined;
      if (clientStore && !(clientStore.clients && clientStore.clients.length)) {
        clientStore.fetchClients?.();
      }
    },
  },
];

export default deploymentStatusRoute;
